// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { iconStyles } from "../../styles/iconStyles";
import {
  bannerStyles,
  pannelStyles,
  formText
} from "../../styles/generalStyles";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...iconStyles(theme),
  ...bannerStyles(theme),
  ...pannelStyles(theme),
  formText,
  icon: {
    marginRight: "5px"
  }
});

type NoItemClassesType = {
  ...IconStylesClassesType,
  appPanelContent: DictionaryType,
  appPanelTop: DictionaryType,
  formText: DictionaryType,
  banner: DictionaryType,
  info: DictionaryType,
  box: DictionaryType,
  content: DictionaryType,
  icon: DictionaryType
};

type NoItemPropsType = {
  classes: NoItemClassesType,
  content: string,
  title?: string
};

class NoItem extends Component<NoItemPropsType, *> {
  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div className={classNames(classes.appPanelContent, classes.appPanelTop)}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            {this.props.title && (
              <h3 className={classes.formText}>{this.props.title}</h3>
            )}
            <div className={classNames(classes.banner, classes.info)}>
              <div className={classes.box}>
                <FolderOpenIcon
                  className={classNames(classes.inheritIcon, classes.icon)}
                />
                <span className={classes.content}>{this.props.content}</span>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(NoItem);
